import { render } from "./HungYen.vue?vue&type=template&id=a8048da2&scoped=true"
import script from "./HungYen.vue?vue&type=script&scoped=true&lang=js"
export * from "./HungYen.vue?vue&type=script&scoped=true&lang=js"

import "./HungYen.vue?vue&type=style&index=0&id=a8048da2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8048da2"]])

export default __exports__